import { useDispatch, useSelector } from "react-redux";
import AllDropDownsAHSF from "../../../../Components/AllDropDownsAHSF";
import InputAHSF from "../../../../Components/InputAHSF";
import TextAreaAHSF from "../../../../Components/TextAreaAHSF";
import "./style.css";
import $ from "jquery";
import { useEffect, useState } from "react";
import { GetAllPublic_ST_TimePeriod } from "../../../../Redux/Reducers/Shared/PublicTimePeriod";
import {
  AddWorkExperience,
  GetOneWorkExperience,
  UpdateWorkExperience,
} from "../../../../Redux/Reducers/Submitter/WorkExperience";
import ButtonAHSF from "../../../../Components/ButtonAHSF";
import Swal from "sweetalert2";
import { setRefreshTable } from "../../../../Redux/Reducers/Shared/VariousVariables";
import { useParams } from "react-router-dom";
const PracticalExperiencesForm = (props) => {
  const [renderData, setRenderData] = useState(false);
  const { ApplicationInformationId } = useParams();
  const TimePeriod = useSelector(
    (state) => state.PublicTimePeriod.PublicTimePeriod
  );
  console.log(TimePeriod, "TimePeriod");

  const dispatch = useDispatch();

  const WorkExperienceResult = useSelector(
    (state) => state.WorkExperience.WorkExperience
  );
  const lang = useSelector((state) => state.languageReducer.Language);
  const [JobTitlePracticalExperiences, setJobTitlePracticalExperiences] =
    useState(null);
  const [
    OrganizationInstitutionUniversity,
    setOrganizationInstitutionUniversity,
  ] = useState(null);
  const [PeriodFromYear, setPeriodFromYear] = useState(null);
  const [PeriodFromYearNumber, setPeriodFromYearNumber] = useState(null);
  const [PeriodToYear, setPeriodToYear] = useState(null);
  const [PeriodToYearNumber, setPeriodToYearNumber] = useState(null);
  const [natureOfWork, setnatureOfWork] = useState(null);
  const [PeriodFromYearText, setPeriodFromYearText] = useState(null);
  const [PeriodToYearText, setPeriodToYearText] = useState(null);
  const [errors, setErrors] = useState({});

  // const [JobTitlePracticalExperiences,setJobTitlePracticalExperiences]=useState(null)
  useEffect(() => {
    dispatch(
      GetAllPublic_ST_TimePeriod({
        academicAchievementShow: false,
        workExperiencePeriodFromYearShow: true,
        workExperiencePeriodToYearShow: false,
        volunteerCommunityWorkPeriodToYearShow: false,
        volunteerCommunityWorkPeriodFromYearShow: false,
        detailsOfResearchSubmittedForAwardLastFiveYearsShow: false,
      })
    );
  }, []);

  console.log(TimePeriod, "TimePeriodTimePeriod");

  const ValidationFunction = () => {
    console.log(JobTitlePracticalExperiences == "", "ddddddddddfefef");

    const newErrors = {};
    if (!JobTitlePracticalExperiences) {
      newErrors.JobTitlePracticalExperiences = true;
    }

    if (!OrganizationInstitutionUniversity) {
      newErrors.OrganizationInstitutionUniversity = true;
    }

    if (!PeriodFromYear) {
      newErrors.PeriodFromYear = true;
    }

    if (!PeriodToYear) {
      newErrors.PeriodToYear = true;
    }

    if (!natureOfWork) {
      newErrors.natureOfWork = true;
    }

    if (PeriodFromYearNumber && PeriodToYearNumber) {
      if (Number(PeriodToYearNumber) < Number(PeriodFromYearNumber)) {
        newErrors.PeriodToYearNumber = true;
      }
    }

    return newErrors;
  };

  const AddWorkExperienceFunction = async () => {
    const newErrors = ValidationFunction();
    setErrors(newErrors);
    if (Object.keys(newErrors).length === 0) {
      const resultAdd = await dispatch(
        AddWorkExperience({
          jobTitle: JobTitlePracticalExperiences,
          organization: OrganizationInstitutionUniversity,
          periodFromYear_TimePeriodId: PeriodFromYear,
          periodToYear_TimePeriodId: PeriodToYear,
          natureOfWork: natureOfWork,
          applicationInformationId:
            localStorage.getItem("ApplicationInformationId") ||
            ApplicationInformationId,
        })
      );

      if (resultAdd.payload.code == 200) {
        Swal.fire({
          position: "center",
          icon: "success",
          title:
            lang == "ar"
              ? "تم اضافة المعلومات بنجاح"
              : "Information Added Successfully",
          showConfirmButton: false,
          timer: 1500,
          // width: "500px",
        });
        dispatch(setRefreshTable({ tableId: "WorkExperience" }));
        if (
          props.setRefreshDataFromClosePagePracticalExperiences != undefined
        ) {
          if (props.refreshDataFromClosePagePracticalExperiences == false) {
            props.setRefreshDataFromClosePagePracticalExperiences(true);
          } else {
            props.setRefreshDataFromClosePagePracticalExperiences(false);
          }
        }
        $(".close-btn").trigger("click");
      }
    }
  };

  const GetData = async () => {
    if (props.FormStatus == "Edit") {
      var result = await dispatch(
        GetOneWorkExperience({ workExperienceId: props.workExperienceId })
      );

      if (result.payload.code == 200) {
        console.log(result?.payload?.result, "sssssssssssssdwdwd");

        setJobTitlePracticalExperiences(result?.payload?.result?.jobTitle);
        setOrganizationInstitutionUniversity(
          result?.payload?.result?.organization
        );
        setPeriodFromYear(result?.payload?.result?.periodFromYear_TimePeriodId);
        setPeriodFromYearNumber(
          result?.payload?.result?.periodFromYear_TimePeriod?.timePeriodNumber
        );
        setPeriodToYearNumber(
          result?.payload?.result?.periodToYear_TimePeriod?.timePeriodNumber
        );
        setPeriodToYear(result?.payload?.result?.periodToYear_TimePeriodId);
        setnatureOfWork(result?.payload?.result?.natureOfWork);

        setPeriodFromYearText(
          result?.payload?.result?.periodFromYear_TimePeriod?.timePeriodNumber
        );
        setPeriodToYearText(
          result?.payload?.result?.periodToYear_TimePeriod?.timePeriodNumber
        );
        setRenderData(true);
      }
    }
  };

  useEffect(() => {
    GetData();
  }, [props.workExperienceId]);

  const EditFunction = async () => {
    const newErrors = ValidationFunction();
    setErrors(newErrors);
    if (Object.keys(newErrors).length === 0) {
      const result = await dispatch(
        UpdateWorkExperience({
          workExperienceId: WorkExperienceResult?.result?.workExperienceId,
          jobTitle: JobTitlePracticalExperiences,
          organization: OrganizationInstitutionUniversity,
          PeriodFromYear_TimePeriodId: PeriodFromYear,
          PeriodToYear_TimePeriodId: PeriodToYear,
          natureOfWork: natureOfWork,
          applicationInformationId:
            WorkExperienceResult?.result?.applicationInformationId,
        })
      );
      if (result.payload.code == 200) {
        Swal.fire({
          position: "center",
          icon: "success",
          title:
            lang == "ar"
              ? "تم تعديل المعلومات بنجاح"
              : "Information Updated Successfully",
          showConfirmButton: false,
          timer: 1500,
          // width: "500px",
        });
        dispatch(setRefreshTable({ tableId: "WorkExperience" }));

        $(".close-btn").trigger("click");
        if (
          props.setRefreshDataFromClosePagePracticalExperiences != undefined
        ) {
          if (props.refreshDataFromClosePagePracticalExperiences == false) {
            props.setRefreshDataFromClosePagePracticalExperiences(true);
          } else {
            props.setRefreshDataFromClosePagePracticalExperiences(false);
          }
        }
      }
    }
  };

  const HTML = (
    <>
      <div className="form-grid-custom-practicalExperiences">
        <div>
          <InputAHSF
            fieldsName="JobTitlePracticalExperiences"
            show={true}
            lang={lang}
            disabled={props.disabled}
            defaultValue={JobTitlePracticalExperiences}
            onChange={(e) => {
              setJobTitlePracticalExperiences(e.target.value);
            }}
            showValidationMessage={errors.JobTitlePracticalExperiences}
            validationMessage={lang == "ar" ? "حقل اجباري" : "Field Required"}
          />
        </div>
        <div>
          <InputAHSF
            fieldsName="OrganizationInstitutionUniversity"
            show={true}
            lang={lang}
            disabled={props.disabled}
            defaultValue={OrganizationInstitutionUniversity}
            onChange={(e) => {
              setOrganizationInstitutionUniversity(e.target.value);
            }}
            showValidationMessage={errors.OrganizationInstitutionUniversity}
            validationMessage={lang == "ar" ? "حقل اجباري" : "Field Required"}
          />
        </div>
        <div>
          <AllDropDownsAHSF
            fieldsName="PeriodFromYear"
            hidelable={false}
            //   labelName={"الجنسية"}
            disabled={props.disabled}
            lang={lang}
            show={true}
            valueEdite={PeriodFromYear}
            submissionStatus={"edite"}
            textEdite={PeriodFromYearText}
            arrayOoptionList={TimePeriod}
            KeyText={lang === "ar" ? "timePeriodNumber" : "timePeriodNumber"}
            id={"timePeriodId"}
            dropdownType={"search"}
            defaultValue={PeriodFromYear}
            value={PeriodFromYear}
            onClickInput={() => {
              dispatch(
                GetAllPublic_ST_TimePeriod({
                  academicAchievementShow: false,
                  workExperiencePeriodFromYearShow: true,
                  workExperiencePeriodToYearShow: false,
                  volunteerCommunityWorkPeriodToYearShow: false,
                  volunteerCommunityWorkPeriodFromYearShow: false,
                  detailsOfResearchSubmittedForAwardLastFiveYearsShow: false,
                })
              );
            }}
            OnClickLi={(e) => {
              setPeriodFromYear(e.timePeriodId);
              setPeriodFromYearNumber(e.timePeriodNumber);
            }}
            showValidationMessage={errors.PeriodFromYear}
            validationMessage={lang == "ar" ? "حقل اجباري" : "Field Required"}
          />
        </div>
        <div>
          <AllDropDownsAHSF
            fieldsName="PeriodToYear"
            hidelable={false}
            //   labelName={"الجنسية"}
            disabled={props.disabled}
            lang={lang}
            show={true}
            valueEdite={PeriodToYear}
            submissionStatus={"edite"}
            textEdite={PeriodToYearText}
            arrayOoptionList={TimePeriod}
            KeyText={lang === "ar" ? "timePeriodNumber" : "timePeriodNumber"}
            id={"timePeriodId"}
            dropdownType={"search"}
            defaultValue={PeriodToYear}
            value={PeriodToYear}
            onClickInput={() => {
              dispatch(
                GetAllPublic_ST_TimePeriod({
                  academicAchievementShow: false,
                  workExperiencePeriodFromYearShow: false,
                  workExperiencePeriodToYearShow: true,
                  volunteerCommunityWorkPeriodToYearShow: false,
                  volunteerCommunityWorkPeriodFromYearShow: false,
                  detailsOfResearchSubmittedForAwardLastFiveYearsShow: false,
                })
              );
            }}
            OnClickLi={(e) => {
              console.log(e, "eeee");

              setPeriodToYear(e.timePeriodId);
              setPeriodToYearNumber(e.timePeriodNumber);
            }}
            showValidationMessage={
              errors.PeriodToYear || errors.PeriodToYearNumber
            }
            validationMessage={
              errors.PeriodToYearNumber
                ? lang === "ar"
                  ? "الفنرة الى سنة يجب ان تكون اكبر من الفترة من سنة"
                  : "End year must be greater than start year"
                : lang === "ar"
                ? "حقل اجباري"
                : "Field Required"
            }
          />
        </div>

        <div>
          <TextAreaAHSF
            fieldsName="natureOfWork"
            show={true}
            lang={lang}
            disabled={props.disabled}
            onChange={(e) => {
              setnatureOfWork(e.target.value);
            }}
            defaultValue={natureOfWork}
            showValidationMessage={errors.natureOfWork}
            validationMessage={lang == "ar" ? "حقل اجباري" : "Field Required"}
          />
        </div>
        {!props.disabled ? (
          <div className="containerButtonsMAinSubmission">
            <ButtonAHSF
              type={"submitter"}
              fieldsName={`${
                props.FormStatus == "Edit" ? "EditButton" : "AddButton"
              }`}
              lang={lang}
              onClick={() => {
                if (props.FormStatus == "Edit") {
                  EditFunction();
                }
                if (props.FormStatus == "Add") {
                  AddWorkExperienceFunction();
                }
              }}
              disabled={false}
              // title={"التالي"}
              // text={"التالي"}
              show={true}
            />
          </div>
        ) : (
          ""
        )}
      </div>
    </>
  );

  if (props.FormStatus == "Edit") {
    if (WorkExperienceResult?.result?.workExperienceId && renderData) {
      return <>{HTML}</>;
    }
  } else if (props.FormStatus == "Add") {
    return <>{HTML}</>;
  }
};

export default PracticalExperiencesForm;
